import React from 'react'
import PropTypes from 'prop-types'
import {
  UploadPlanAgreementModal,
  DownloadNotAvailableModal,
  ReInitializeDocusignModal,
} from '../components'

const propTypes = {
  showUploadModal: PropTypes.bool.isRequired,
  setShowUploadModal: PropTypes.func.isRequired,
  showDownloadNotAvailableModal: PropTypes.bool.isRequired,
  setShowDownloadNotAvailableModal: PropTypes.func.isRequired,
  showResendModal: PropTypes.bool.isRequired,
  setShowResendModal: PropTypes.func.isRequired,
  servicesAgreement: PropTypes.object,
  servicesAgreementId: PropTypes.string,
  portalAgreementStatus: PropTypes.string,
  agreementsType: PropTypes.string,
  onUploadSuccess: PropTypes.func.isRequired,
}
const defaultProps = {}

function AgreementDetailsModals({
  showUploadModal,
  setShowUploadModal,
  showDownloadNotAvailableModal,
  setShowDownloadNotAvailableModal,
  showResendModal,
  setShowResendModal,
  servicesAgreement,
  servicesAgreementId,
  portalAgreementStatus,
  onUploadSuccess,
  agreementsType,
}) {
  return (
    <>
      {showUploadModal && (
        <UploadPlanAgreementModal
          onClose={() => setShowUploadModal(false)}
          servicesAgreement={servicesAgreement}
          onSubmitSuccess={onUploadSuccess}
          agreementsType={agreementsType}
        />
      )}
      {showDownloadNotAvailableModal && (
        <DownloadNotAvailableModal
          onClose={() => setShowDownloadNotAvailableModal(false)}
        />
      )}
      {showResendModal && (
        <ReInitializeDocusignModal
          agreementId={servicesAgreementId}
          onClose={() => setShowResendModal(false)}
          productAgreementType={agreementsType}
          status={portalAgreementStatus}
        />
      )}
    </>
  )
}

AgreementDetailsModals.propTypes = propTypes
AgreementDetailsModals.defaultProps = defaultProps

export default AgreementDetailsModals
